import styled from "styled-components";

export const TabsWrapper = styled.div`
  button {
    padding: 25px 25px;
    border: none;
    background-color: transparent;
    color: #fff;
    cursor: pointer;   
    line-height: 18px;
    font-weight: 600;
    &.active {
      border-radius: 5px;
      background-color: #FFFF;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
      color: #4f4f4f;
    }
  }
`;

export const ViewAdminWrapper = styled.div`
  border-radius: 5px;
  background-color: #f7f8f9;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
  padding: 38px 32px;
  margin-top: 34px;
  .support-usr-typ {
    width: 235px;
  }
  .change-status-actions {
    .tooltip {
      position: absolute;
      display: none;
      right: 16px;
      top: -8px;
      padding-right: 8px;
      ul {
        position: relative;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
        border-radius: 5px;
        &:after {
          content: "";
          width: 8px;
          height: 8px;
          background-color: #fff;
          position: absolute;
          top: 12px;
          right: -4px;
          box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.1);
          transform: rotate(-45deg);
        }
        li {
          padding: 3px 10px;
          background-color: #fff;
          position: relative;
          z-index: 1;
          &:first-child {
            border-radius: 5px 5px 0 0;
          }
          &:last-child {
            border-radius: 0 0 5px 5px;
          }
          &:hover {
            background-color: #f0f3f4;
          }
        }
      }
    }
    &:hover {
      .tooltip {
        display: block;
      }
    }
  }
    /* Toggle switch style */
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(24px);
}

.slider.round {
  border-radius: 34px;
}

`;

export const AddAdminWrapper = styled.div`
  max-width: 70%;
 
`;
